import type { VoucherPersonView } from './views/voucher_skeleton_view.js';
import type { Voucher } from './services.js';

/** Quem viaja, para a linha de identidade de todo voucher: o nome e o id do
 *  perfil, por onde a tela pede a foto na hora de desenhar (#2640). */
export function voucherTraveler(voucher: Voucher): {
  travelerName: string | null;
  travelerId: string | null;
} {
  return { travelerName: voucher.traveler?.name ?? null, travelerId: voucher.traveler?.id ?? null };
}

/** Quem MAIS viaja neste voucher — os acompanhantes dividem o PNR/reserva do
 *  viajante, e o balcão pede o nome de todos (a mesma razão do `guestLine`).
 *  Entram na identidade SÓ em voo/ônibus: no hotel eles já moram no campo
 *  Hóspedes, e repeti-los seria uma segunda afirmação dos mesmos nomes. Nome em
 *  branco não vira avatar fantasma; lista vazia = viaja só, e o campo não nasce.
 *  O id vai junto para a foto (#2640). */
export function companionPeople(voucher: Voucher): VoucherPersonView[] | undefined {
  const people = voucher.companions.flatMap((c) => {
    const name = c.name?.trim();
    return name ? [{ id: c.id, name }] : [];
  });
  return people.length > 0 ? people : undefined;
}
